
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '全称',
value: this.$route.params.Item.PCN_Name
}, {
label: '简称',
value: this.$route.params.Item.PCN_Name_Abbr
}, {
label: '描述',
value: this.$route.params.Item.PCN_Remark
}]
}
}



// WEBPACK FOOTER //
// ./src/components/CompanyNatureDetail.vue